import React from 'react';
import { theme } from 'antd';
import { useResponsive } from '@/hooks/useResponsive';

const { useToken } = theme;

interface ReportIconProps {
  color?: string;
  size?: number;
  [x: string]: unknown;
}

const ReportIcon = ({ size, ...rest }: ReportIconProps) => {
  const { token } = useToken();
  const { isMobile, isTablet } = useResponsive();

  const getResponsiveSize = () => {
    if (size) return { width: size, height: size * 0.56 }; 
    if (isMobile) return { width: 36, height: 20 };
    if (isTablet) return { width: 42, height: 24 };
    return { width: 50, height: 28 }; 
  };

  const { width, height } = getResponsiveSize();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 28"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect id="background" width="40" height="28" rx="2" fill={token.colorBorder} />
      <polyline
        points="8,18 16,12 23,16 31,9"
        fill="none"
        stroke={token.colorBgBase}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReportIcon;